import { createPortal } from 'react-dom'
import { Link, useNavigate} from 'react-router-dom'

const USCModal = ({ onClose }: { onClose: () => void }) => {
  const navigate = useNavigate();
  
    const handleClose = () => {
      if (onClose) {
        onClose();
      } else {
        navigate(-1);
      }
    };
  return createPortal(
    <div id="modal-example" className="pf-modal">
      <div className="pf-modal__dialog">
        <div className="pf-modal__content">
          <div className="pf-modal__body">
            <div className="pf-page__logo">
              <div className="pf-page__logo-content">
                <img
                  src='/logo.png'
                  alt='AllFans'
                  className='pf-page__logo-img'
                />
              </div>
            </div>
            <h2 className="pf-page__title">
              All<span>Fans</span>
            </h2>
            <div className="pf-page__descr">18 U.S.C. § 2257 Statement</div>
                    <div className="pf-main-list">
            <p>Last Updated: 2025/06/21</p>
            <p>Any actual human being that appears in any visual depiction of actual sexually explicit conduct 
                appearing or otherwise contained on the website located at <Link to="/">www.allfans.com</Link> (“Website”) were at least 
                18-years old at the time those visual depictions were produced.</p>
            
            <h5>Exemption: Content Produced by Third Parties</h5>
                <p>The Website’s operator is not the “producer” of any depictions of actual or simulated sexually explicit 
                    conduct that may appear on the Website. The Website’s operator limits its handling of this content and only 
                    performs the activities of transmission, storage, retrieval, hosting, or formatting of material that may depict 
                    sexually explicit conduct, all which material appears on the Website as the result of actions taken by 
                    third-party users of the Website. All parts of the Website that contain user-generated material are under the 
                    control of the relevant user, for whom the Website is provided as an online service by the operator. Under 
                    18 U.S.C. § 2257(h)(2)(B)(v) and 47 U.S.C. § 230(c), the Website’s operator may delete materials appearing on 
                    the Website as the result of actions taken by the Website’s users, which materials are considered, in the 
                    operator’s sole discretion, to be indecent, obscene, defamatory, or inconsistent with the policies and terms 
                    of use for the Website.</p>
            
            <h5>Exemption: Content Produced by Website Operator</h5>
                <p>To the extent that any images or videos appear on the Website, for which the Website’s operator may be 
                    considered the “producer,” those images and videos are exempt from the requirements of 18 U.S.C. § 2257 
                    and 28 C.F.R. Part 75 for one or more of the following reasons: (1) the produced images or videos do not 
                    portray any sexually explicit conduct defined in 18 U.S.C. § 2256(2)(A); (2) the produced images or videos 
                    do not portray depictions of the genitals or pubic area created after July 27, 2006; (3) the produced images 
                    or videos do not portray simulated sexually explicit activity occurring after the effective date of 
                    18 U.S.C. § 2257A; or (4) the produced images or videos were created before July 3, 1995.</p>
            
            <h5>Designated Records Custodian</h5>
                <p>Without limiting in any way the applicability of the above-stated exemptions, the Website’s operator has 
                    designated the custodian, whose address appears below, to be the keeper of original records described in 
                    18 U.S.C. § 2257 and 28 C.F.R. Part 75 for all materials appearing on the Website that fall in the 
                    following categories: (1) marketing and advertising materials that contain visual depictions of actual 
                    or simulated sexually explicit conduct, which materials have been acquired or created by the Website’s 
                    operator to promote the Website; or (2) materials that are not exempt, as described above.</p>
                
                <p>The named earlier records and their custodian can be found at the following location:</p>
                <p>Custodian of Records<br></br>
                Innodev Solutions Inc.<br></br>
                2108 N ST #6819
                SACRAMENTO, CA 95816
                </p>
          </div>
          </div>
        </div>
          <div className="pf-modal__footer">
            <div className="pf-page__social">
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-default"
                style={{
                  width: '100%',
                  maxWidth: '220px'
                }}
              >
                Close
              </button>
            </div>
          </div>
      </div>
    </div>, document.body
  )
}

export default USCModal
